import Action from '../base/action';

class MediaScreenChangePage extends Action {
    mediaId;
    pageNumber;

    constructor(props) {
        super({...props, className: props.className || props.type + '_class'});
        this.mediaId = props.instanceId;
        this.pageNumber = props.pageNumber;
    }

    async execute({training}) {
        const media = MediaScreenManager.getMediaScreenFromInstanceId(this.mediaId);

        if (isNullOrUndefined(media)) {
            console.log('Media not found for id: ' + this.mediaId);
            return;
        }

        media.loadPage(this.pageNumber);
    }

    async stop() {
        const media = MediaScreenManager.getMediaScreenFromInstanceId(this.mediaId);

        if (isNullOrUndefined(media)) {
            console.log('Media not found for id: ' + this.mediaId);
            return;
        }

        MediaScreenManager.changeScreenVisibility(media.params.screenID, false);
        media.loadPage(1);
    }
}

export default MediaScreenChangePage;
